export default "__VITE_ASSET__gDy9DhJc__"